import { render } from "./Servicio.vue?vue&type=template&id=458c9d62&scoped=true"
import script from "./Servicio.vue?vue&type=script&lang=js"
export * from "./Servicio.vue?vue&type=script&lang=js"

import "./Servicio.vue?vue&type=style&index=0&id=458c9d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458c9d62"]])

export default __exports__